<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 查询管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>扫码模板管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="add.addshow=!add.addshow , update.show = false"
        >新建模板</el-button>
      </div>
      <br id="A1" />
      <!--步骤条 填写基础信息 -->
      <Add-Scan :add="add" :search="search" />
      <Update-Scan ref="mychild" :update="update" :search="search" />
      <br />
      <el-divider></el-divider>
      <el-row type="flex" class="row-bg">
        <el-col :span="24">
          <el-table
            v-loading="listLoading"
            element-loading-text="拼命加载中"
            :data="tableData"
            border
            style="width:100%"
          >
            <el-table-column prop="templateId" label="模板" min-width="280"></el-table-column>
            <el-table-column label="操作" min-width="100" show-overflow-tooltip>
              <template slot-scope="props">
                <el-button-group>
                  <el-button
                    type="primary"
                    @click="getoutbilldata(props.row),update.show =true , add.addshow=false"
                  >修改</el-button>
                  <el-button type="danger" @click="deldata(props.row)">删除</el-button>
                </el-button-group>
              </template>
            </el-table-column>
            <el-table-column label="启用状态" min-width="100" show-overflow-tooltip>
              <template slot-scope="props">
                <el-switch
                  v-model="props.row.ifEnable"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  @change="enable(props.row)"
                ></el-switch>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import AddScan from "./components/AddScan";
import UpdateScan from "./components/UpdateScan";
import { findcontent, deletecontent, usecontent } from "@/api/qrcode";
export default {
  components: {
    AddScan,
    UpdateScan
  },
  data() {
    return {
      add: {
        addshow: false
      },
      update: {
        form: {
          templateId: null
        },
        checkedCities: [],
        tablelist: [],
        show: false,
        arrlist: []
      },
      value: true,
      listLoading: false,
      arrlist: [],
      imgsrc:
        process.env.VUE_APP_BASE_API_baseinfo +
        "/api/out/qrcodescantemplate/findcontentpic?picUrl=",
      tableData: [],
      searchform: {
        templateId: 1
      },
      options: [
        {
          value: 1,
          label: "通用模板"
        },
        {
          value: 2,
          label: "简约模板"
        },
        {
          value: 3,
          label: "定制模板"
        }
      ]
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    search() {
      findcontent().then(res => {
        this.tableData = res.data;
        // console.log(this.tableData);
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].list[0].templateId == 1) {
            this.tableData[i].templateId = "通用模板";
          } else if (this.tableData[i].list[0].templateId == 2) {
            this.tableData[i].templateId = "简约模板";
          } else if (this.tableData[i].list[0].templateId == 3) {
            this.tableData[i].templateId = "定制模板";
          }
        }
      });
    },
    getoutbilldata(row) {
      this.update.form.templateId = row.list[0].templateId;
      function compare(prop) {
        return function(a, b) {
          let v1 = a[prop];
          let v2 = b[prop];
          return v1 - v2; //从小到大排序
        };
      }
      this.arrlist = row.list;
      this.update.tablelist = this.arrlist.sort(compare("templateOrder"));
      if (row.list[row.list.length - 1].type == 4) {
        this.update.checkedCities = row.list[row.list.length - 1].content.split(
          ","
        );
      }
      // console.log(this.update.tablelist);
    },
    deldata(row) {
      // console.log(row);
      deletecontent({ tempid: row.list[0].templateId }).then(res => {
        if (res.status_code == 200) {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          this.search();
        } else {
          return;
        }
      });
    },
    enable(row) {
      usecontent({ tempid: row.list[0].templateId }).then(res => {
        if (res.status_code == 200) {
          this.$message({
            type: "success",
            message: "启用成功!"
          });
          this.search();
        } else {
          return;
        }
      });
    }
  }
};
</script>

<style>
</style>